"use client";

import { useState } from "react";
import "./JoinUsSection1.css";
import BillboardImg from "../../../assets/virtue billboard png 2.png";
import { useTranslation } from "react-i18next";

function JoinUsSection1() {
  const { t } = useTranslation("global");
  const [searchQuery, setSearchQuery] = useState("");
  const [notification, setNotification] = useState("");

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setNotification(t("joinUsSection1.notifications.noJobOffers"));
  };

  return (
    <section className="careers-section" aria-labelledby="careers-heading">
      <div className="job-search-container">
        <div className="job-search-content">
          {notification && (
            <div className="notification" role="alert" aria-live="polite">
              {notification}
            </div>
          )}

          <h1 id="careers-heading" className="no-offers-heading">
            {t("joinUsSection1.noOffersHeading")}
          </h1>

          <form
            className="search-bar-container"
            onSubmit={handleSearch}
            role="search"
            aria-label="Job search"
          >
            <div className="search-input-wrapper">
              <input
                id="job-search"
                type="search"
                placeholder={t("joinUsSection1.searchPlaceholder")}
                className="search-input"
                value={searchQuery}
                onChange={handleSearchChange}
                aria-label={t("joinUsSection1.searchPlaceholder")}
              />
              <button
                type="submit"
                className="search-icon-button"
                aria-label={t("joinUsSection1.searchButton")}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                  role="img"
                >
                  <title>Search icon</title>
                  <circle cx="11" cy="11" r="8"></circle>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                </svg>
              </button>
            </div>

            <button
              type="button"
              className="filters-button"
              aria-expanded="false"
              aria-controls="filter-options"
            >
              {t("joinUsSection1.filtersButton")}
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="chevron-down"
                aria-hidden="true"
              >
                <title>Down arrow</title>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </button>

            <button type="submit" className="search-button">
              {t("joinUsSection1.searchButton")}
            </button>
          </form>

          <article className="company-section">
            <div className="company-logo-container">
              <img
                src={BillboardImg}
                alt={t("joinUsSection1.companyLogoAlt")}
                className="company-logo"
                loading="lazy"
                width="400"
                height="225"
                title="Virtue Company Logo"
              />
            </div>

            <div className="company-description">
              <p>{t("joinUsSection1.companyDescription.paragraph1")}</p>
              <p>{t("joinUsSection1.companyDescription.paragraph2")}</p>
            </div>
          </article>
        </div>
      </div>
      <div className="divider-line" aria-hidden="true"></div>
      <hr className="divider-line" />
    </section>
  );
}

export default JoinUsSection1;
